import { Container, ContentGroup } from "./style";
import ChooUs1 from "../../../../assets/img/Langding/imgChoosUs1.png";
import ChooUs2 from "../../../../assets/img/Langding/imgChoosUs2.png";
import ChooUs3 from "../../../../assets/img/Langding/imgChoosUs3.png";

const ChooseUs = () => {
  return (
    <Container>
      <h1>Why Choose Us?</h1>
      <ContentGroup>
        <div>
          <img src={ChooUs1} alt="" />
          <h3>Direct impact</h3>
          <p>
            Our project prioritizes community engagement for a positive
            environmental impact.
          </p>
        </div>
        <div>
          <img src={ChooUs2} alt="" />
          <h3>Carbon Certificates</h3>
          <p>
            We use carbon certificates to offset our carbon footprint and
            promote sustainable crypto practices.
          </p>
        </div>
        <div>
          <img src={ChooUs3} alt="" />
          <h3>Decentralization</h3>
          <p>
            Our decentralized blockchain ensures transparency, security, and
            independence from government and corporate control.
          </p>
        </div>
      </ContentGroup>
    </Container>
  );
};
export default ChooseUs;
